import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import EventsUsersProfilesListView from "./events_users_profiles-list.html";
import EventsUsersProfilesEditView from "./events_users_profiles-edit.html";


angular.module("events_users_profiles", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('events_users_profiles', {
                url: "/events_users_profiles",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('events_users_profiles.list', {
                url: "/list",
                controller: "EventsUsersProfilesListCtrl",
                template: EventsUsersProfilesListView,
                requiredPermission: ["EVENTS_USERS_PROFILES_READ"]
            })             
            .state('events_users_profiles.edit', {
                url: "/edit/:id",
                controller: "EventsUsersProfilesEditCtrl",
                template: EventsUsersProfilesEditView,
                requiredPermission: ["EVENTS_USERS_PROFILES_READ"]
            })
    }])
;